import { Flex } from '@chakra-ui/react';
import { OnSubmissionStateChange } from '@melio/penny';
import { FundingSource } from '@melio/platform-api';
import { Logger } from '@melio/platform-logger';
import { SubscriptionBillingCycleEnum } from '@melio/subscriptions-api';
import { useState } from 'react';

import { CardFundingSourceFormFields } from '../CardFundingSourceForm/types';
import { SubscriptionBillingCycle } from './components/SubscriptionBillingCycle';
import { SubscriptionPaymentMethod } from './components/SubscriptionPaymentMethod';

type SubscriptionCheckoutSelectionProps = {
  columns: number;
  isPlanSaving: boolean;
  fundingSources?: FundingSource[] | undefined;
  isLoading: boolean;
  newFundingSourceId?: string;
  onCreateCardDetailsDone: (fields: CardFundingSourceFormFields) => Promise<void>;
  onAddBankAccountClicked: VoidFunction;
};

export const SubscriptionCheckoutSelection = ({
  columns,
  isPlanSaving,
  isLoading,
  fundingSources,
  newFundingSourceId,
  onCreateCardDetailsDone,
  onAddBankAccountClicked,
}: SubscriptionCheckoutSelectionProps) => {
  const [billingCycle, setBillingCycle] = useState<SubscriptionBillingCycleEnum>(SubscriptionBillingCycleEnum.Yearly);

  const onBillingCycleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newCycle = e.target.value as SubscriptionBillingCycleEnum;
    setBillingCycle(newCycle);
  };

  const onSubmissionStateChange: OnSubmissionStateChange<CardFundingSourceFormFields> = () => {
    Logger.log(`Submission state changed`, 'debug');
  };

  const onSubmit = (fields: CardFundingSourceFormFields) => {
    onCreateCardDetailsDone(fields).catch((error) => {
      Logger.log(`Error: ${error as string}`, 'error');
    });
  };

  return (
    <Flex flexDir="column" width="full" gap="l" flex={{ xs: 'none', m: columns }}>
      <SubscriptionBillingCycle
        billingCycle={billingCycle}
        isPlanSaving={isPlanSaving}
        onBillingCycleChange={onBillingCycleChange}
      />
      <SubscriptionPaymentMethod
        fundingSources={fundingSources}
        newFundingSourceId={newFundingSourceId}
        onAddBankAccountClicked={onAddBankAccountClicked}
        isLoading={isLoading}
        onSubmissionStateChange={onSubmissionStateChange}
        onSubmit={onSubmit}
      />
    </Flex>
  );
};
